/**
 * Game-related type definitions for the 4 in a Row game
 */

import { IAvatar } from './avatar-types';

export enum PlayerType {
  Human = 'human',
  Computer = 'computer',
}

export enum GameMode {
  PlayerVsPlayer = 'player-vs-player',
  PlayerVsComputer = 'player-vs-computer',
}

export enum GameStatus {
  NotStarted = 'not-started',
  InProgress = 'in-progress',
  Won = 'won',
  Draw = 'draw',
}

export enum PieceColor {
  Red = 'red',
  Yellow = 'yellow',
}

export interface IPosition {
  row: number;
  column: number;
}

export interface IWinningLine {
  positions: IPosition[];
  direction: 'horizontal' | 'vertical' | 'diagonal-ascending' | 'diagonal-descending';
}

export interface IGameState {
  board: (PieceColor | null)[][];
  currentPlayer: 1 | 2;
  status: GameStatus;
  winner: 1 | 2 | null;
  winningLine: IWinningLine | null;
  moveHistory: IPosition[];
}

export interface IPlayer {
  id: 1 | 2;
  name: string;
  type: PlayerType;
  color: PieceColor;
  avatar: IAvatar;
}

export interface IGameConfig {
  mode: GameMode;
  player1: IPlayer;
  player2: IPlayer;
  rows: number;
  columns: number;
}

export type AIDifficulty = 'easy' | 'medium' | 'hard';

export interface IAIConfig {
  difficulty: AIDifficulty;
  lookAheadDepth: number;
}
